import "bootstrap/js/modal";

export class ModalDialog {
  /**
   *
   * @param {string} id - CSS selector
   * @param {DataEntry} dataEntry
   * @param {boolean} addConfirmListener - add a listener on confirm button based on dataset attributes (url, action, id)
   */
  constructor(id, dataEntry, addConfirmListener = false) {
    this.id = id;
    this.dataEntry = dataEntry;

    if (addConfirmListener) {
      this.addConfirmButtonListener();
    }
  }

  /**
   *
   * @param {*} id
   */
  addConfirmButtonListener() {
    const modal = document.getElementById(this.id);
    const el = modal.querySelector(".btn-success");
    if (el) {
      el.addEventListener(
        "click",
        (e) => {
          const url = e.srcElement.dataset.url;
          const id = e.srcElement.dataset.eventId;
          const action = e.srcElement.dataset.action;
          this.handleAction(url, id, action);
        },
        false
      );
    }
  }
  /**
   *
   * @param {HTMLElement} el
   * @param {string} action
   */
  onClick(el, action) {
    el.addEventListener(
      "click",
      (e) => {
        e.preventDefault();

        const modal = document.getElementById(this.id);
        const confirmButton = modal.querySelector(".btn-success");
        const url = el.dataset.url;
        const id = el.dataset.eventId;

        if (confirmButton) {
          confirmButton.dataset.url = url;
          confirmButton.dataset.eventId = id;
          confirmButton.dataset.action = action;
          this.show();
        } else {
          this.handleAction(url, id, action);
        }
      },
      false
    );
  }

  /**
   *
   * @param {*} url
   * @param {*} id
   * @param {*} action
   */
  handleAction(url, id, action) {
    switch (action) {
      case "edit-history-event":
        window.location.href = url;
        break;
      case "delete-event":
      case "delete-history-event":
      case "delete-favourite":
        this.dataEntry
          .deleteEvent(url)
          .then((response) => response.clone().json())
          .then((data) => {
            if (action === "delete-history-event" && data.status === "ok") {
              const table = $(".table").DataTable();
              const tr = $(`table [data-event-id='${id}'][data-target='#delete-history-event']`).closest("tr");
              const td = tr.find(tr.find("td:eq(4)"));

              td.html(
                `<label class="label label-success">${this.dataEntry.translate(
                  "pending.eventcorrection"
                )}</label><label class="label label-danger">${this.dataEntry.translate(
                  "history.eventcorrection.erroneous"
                )}</label>`
              );
              table.row(tr).invalidate("dom");
              return;
            }

            if (action === "delete-event" && this.dataEntry.displayPendingCount === "true") {
              this.dataEntry.menu.displayPendingCount(this.dataEntry.pendingCount - 1);
            }

            const elRow = document.getElementById(id);
            if (elRow) {
              elRow.remove();
            }
          });
        break;
      case "preview-xml":
        this.dataEntry
          .previewXml(url)
          .then((response) => response.clone().json())
          .then((data) => {
            if (!data.xml) {
              return;
            }
            const modal = document.getElementById(this.id);
            const textarea = modal.querySelector("textarea");
            textarea.innerHTML = data.xml;
            this.show();
          });
        break;
    }
  }

  /**
   *
   */
  show() {
    const modal = document.getElementById(this.id);
    $(modal).modal();
  }

  hide() {
    const modal = document.getElementById(this.id);
    $(modal).modal("hide");
    $("body").removeClass("modal-open");
    $(".modal-backdrop").remove();
  }
}
